import Swiper from 'swiper';
import {  Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export default function (element, data) {
    const swiperOptions = {
        modules: [ Navigation, Pagination],
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        watchOverflow: true,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        navigation: {
            nextEl: element.querySelector(".swiper_button-next"),
            prevEl: element.querySelector(".swiper_button-prev"),
        },
        pagination: {
            el: element.querySelector(".custom-swiper-pagination"),
            type: 'bullets',
            clickable: true
        },
        breakpoints: {
            1500: {
                slidesOffsetBefore: (window.innerWidth - 1540 + 250) / 2,
                slidesOffsetAfter: 125,
                spaceBetween: 30,
            },
            992: {
                slidesOffsetBefore: 60,
                slidesOffsetAfter: 60,
                spaceBetween: 20,
            },
        }
    };

    // element.swiper = new Swiper(element.querySelector(".swiper-articles"), swiperOptions);
    const swiper = new Swiper(
        element.querySelector(".swiper-articles"),
        swiperOptions
    );

    const paginationEl = element.querySelector(".custom-swiper-pagination");

    if (swiper.isLocked) {
        paginationEl.style.display = 'none';
    }

    swiper.on('lock unlock', function () {
        paginationEl.style.display = swiper.isLocked ? 'none' : '';
    });

    element.swiper = swiper;
};